// extracted by mini-css-extract-plugin
export default {"photoCellsRow":"photoCellsRow_photoCellsRow__lFzXe","photo":"photoCellsRow_photo__+qzYb","noPhoto":"photoCellsRow_noPhoto__bl5yf"};